var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOramentoEnviado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "or\\xE7amento-enviado",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.001,
    viewBox: "0 0 15 15.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1535",
    "data-name": "Caminho 1535",
    d: "M7.535,15a7.5,7.5,0,1,1,5.3-2.2A7.5,7.5,0,0,1,7.535,15Zm0-14.122A6.621,6.621,0,1,0,14.156,7.5,6.629,6.629,0,0,0,7.535.881Z",
    transform: "translate(-0.036 -0.002)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1536",
    "data-name": "Caminho 1536",
    d: "M188.167,137.354a2.047,2.047,0,1,1,2.047-2.047.439.439,0,1,1-.879,0,1.168,1.168,0,1,0-1.168,1.168.439.439,0,1,1,0,.879Z",
    transform: "translate(-180.668 -129.356)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1537",
    "data-name": "Caminho 1537",
    d: "M188.187,247.095a2.049,2.049,0,0,1-2.047-2.047.439.439,0,1,1,.879,0,1.168,1.168,0,1,0,1.168-1.169.439.439,0,1,1,0-.879,2.047,2.047,0,1,1,0,4.094Z",
    transform: "translate(-180.688 -235.881)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1538",
    "data-name": "Caminho 1538",
    d: "M241.439,91.478a.439.439,0,0,1-.439-.439V89.749a.439.439,0,1,1,.879,0v1.289a.439.439,0,0,1-.439.439Z",
    transform: "translate(-233.94 -86.693)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1539",
    "data-name": "Caminho 1539",
    d: "M241.439,354.818a.439.439,0,0,1-.439-.439V353.21a.439.439,0,1,1,.879,0v1.169A.439.439,0,0,1,241.439,354.818Z",
    transform: "translate(-233.94 -342.435)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOramentoEnviado);
export default __webpack_public_path__ + "static/media/orçamento-enviado.ca6c37b3ccc7fad19f5502f5e89b2722.svg";
export { ForwardRef as ReactComponent };